import { AdminCampaignRun } from '@app/Campaigns/types';

export interface AdminDriverSummary {
  driverProfileId: number;
  userId: number | null;
  name: string | null;
  email: string | null;
  available: boolean | null;
  pairedScreenId: number | null;
  pairedScreenName: string | null;
  runsTotal: number;
  runsCompleted: number;
  runsAborted: number;
  runsInProgress: number;
  runsApproved: number;
  runsDeclined: number;
  runsPendingApproval: number;
  distanceMeters: number;
}

export interface AdminDriverDetail {
  summary: AdminDriverSummary;
  recentRuns: AdminCampaignRun[];
}

/** Accept rate from approved vs declined runs, or null if the driver has neither. */
export function acceptRate(d: { runsApproved: number; runsDeclined: number }): number | null {
  const denom = d.runsApproved + d.runsDeclined;
  if (denom <= 0) return null;
  return Math.round((d.runsApproved / denom) * 100);
}
